import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
  import router from "@/router";
  import MainLayout from "./layouts/MainLayout.vue";
  import EmptyLayout from "./layouts/EmptyLayout.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props, { expose: __expose }) {
  __expose();

  const layout = computed(() => {
    const { meta, fullPath } = router.currentRoute.value;

    if (fullPath === "/") {
      return EmptyLayout;
    }

    return meta.layout || MainLayout;
  });

const __returned__ = { layout, computed, get router() { return router }, MainLayout, EmptyLayout }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})